module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "part_no"
  }, [_vm._v("PART 1")]), _vm._v(" "), _c('p', {
    staticClass: "fmimageb"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "part_title"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EING A")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IREWORK")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/part.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As you read this book, I encourage you to understand this: One of the greatest gifts we are given in life is the ability to transform. If we allow ourselves, we can—at any point—decide to make a change. Transformation can happen in a dramatic, sudden way or organically over time. To fight it or stay stuck or complacent is a tragedy for yourself. In the transformation or evolution of ourselves, we discover our magic, our hidden gems, and curiosity starts to bloom, and we become free to be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In these first few chapters, I will share what I feel are foundational principles to igniting the sparks to becoming a Firework Human. Embrace new ideas, be encouraged by the familiar, and know that it’s never too late for you to spark—or "), _c('i', [_vm._v("be")]), _vm._v(" the spark in someone else’s journey!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e32aa114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 78
// module chunks = 0